<template>
  <div class="add-to-homescreen-banner" v-if="showAddToHomeScreen">
    <i class="fas fa-times close" @click="close"></i>
    <AddToHomeScreen
      @finish="close"
      :studioName="studio.studio_name"
      :appIcon="appIcon"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import AddToHomeScreen from '@/web/components/pwa/AddToHomeScreen';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'AddToHomeScreenBanner',
  components: {
    AddToHomeScreen,
  },
  methods: {
    close() {
      this.$store.dispatch('globals/setShowInstallPWA', false);
    },
  },
  computed: {
    ...mapGetters({
      isPWA: 'globals/isPWA',
      showCookieNotice: 'globals/showCookieNotice',
      studio: 'studio/currentStudio',
      showInstallPWA: 'globals/showInstallPWA',
    }),
    showAddToHomeScreen() {
      return (
        this.studio && // studio is loaded
        !this.isPWA && // instance is not PWA app
        !this.showCookieNotice && // first user has to confirm cookie notice
        this.showInstallPWA // notice was not dismiss yet
      );
    },
    appIcon() {
      return this.studio?.app_icon?.thumbnail;
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.add-to-homescreen-banner {
  z-index: 10000;
  border-top: 1px solid $medium-gray;
  width: 100%;
  box-sizing: border-box;
  background: white;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 1rem;
}

.close {
  padding: 1rem;
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 0;
}
</style>
